import React, {useEffect, useContext, useState} from "react"
import PropTypes from "prop-types"

import {AppContext} from "../components/context/AppContext"
import { OfferApi } from "../utils/api"

import { MaintenanceModeComponent, CheckStatusComponent } from "../components"
import { NursesTeachersGetStartedComponent, NursesTeachersWelcomeComponent } from "../components/NursesTeachers"

const offerId = Number.parseInt(process.env.REACT_APP_TVISION_OFFER_ID)

export const NursesTeachers = () => {
  const {dispatch, state} = useContext(AppContext)
  const [inMaintenanceMode, setInMaintenanceMode] = useState(true)
  const [maintenanceText, setMaintenanceText] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isErrorFetchingMaintenanceText, setIsErrorFetchingMaintenanceText] = useState(false)

  useEffect(() => {
    dispatch({type: "RESETUSER"})
  }, [dispatch])

  useEffect(() => {
    const checkMaintenanceMode = async () => {

      setIsLoading(true)
      try {
        const clientMaintenanceFlagResult = await OfferApi.getClientAsset("MaintenanceFlag")

        const clientMaintenanceText = await OfferApi.getClientAsset("MaintenanceText")

        if (clientMaintenanceFlagResult.notes.toLowerCase() === "true") {
          setMaintenanceText(clientMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        const offerMaintenanceFlag = await OfferApi.getOfferAsset(offerId, "MaintenanceFlag")
        const offerMaintenanceText = await OfferApi.getOfferAsset(offerId, "MaintenanceText")

        if (offerMaintenanceFlag.notes.toLowerCase() === "true") {
          setMaintenanceText(offerMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        setInMaintenanceMode(false)
      } catch (error) {
        if (error.message === "Unable to retrieve client asset") {
          setIsErrorFetchingMaintenanceText(true)
        }
        setErrorMessage("Something went wrong. Please try again.")
      } finally {
        setIsLoading(false)
      }
    }

    checkMaintenanceMode()
  }, [inMaintenanceMode])

  const ActiveContent = () => (
    <>
      <NursesTeachersGetStartedComponent errorMessage={state.commonError} offerId={offerId} setErrorMessage={setErrorMessage} />
      <CheckStatusComponent sprintRedirectActive={true} />
    </>)

  return (
    <>
    <NursesTeachersWelcomeComponent />
    {isErrorFetchingMaintenanceText &&
    <div className="text-center container">
      <h1 className="magenta">Temporarily Unavailable</h1>
      <p>This site is currently under going scheduled maintenance. We&apos;ll be back soon.</p>
      <p> Thank you for your patience.</p>
    </div> }
    {isLoading && <div style={{textAlign: "center"}}>Loading ...</div>}
    {errorMessage.length > 0 && !isLoading && !isErrorFetchingMaintenanceText && <div style={{textAlign: "center"}}>{errorMessage}</div>}
    {inMaintenanceMode && !isLoading && <MaintenanceModeComponent maintenanceText={maintenanceText} />}
    {!inMaintenanceMode && !isLoading && !isErrorFetchingMaintenanceText && <ActiveContent /> }
    </>
  )
}

NursesTeachers.propTypes = {
  history: PropTypes.object
}
